<template>
    <div class="body">

    <div class="contractList">
        <ul class="infinite-list" v-infinite-scroll="getList" style="overflow:auto">
            <li v-for="(item,i) in list" :key="i" @click="info(item.id)" class="infinite-list-item">
                <el-row>
                    <el-col :span="18" class="listLeft">
                        <div class="title van-ellipsis" >{{item.project}}</div>
                        <div class="num van-ellipsis">合同编号：{{item.num}}</div>
                    </el-col>
                    <el-col :span="6" class="listRight">
                        点击查看<i class="el-icon-arrow-right"></i>
                    </el-col>
                </el-row>
            </li>
          </ul>
    </div>
</div>
</template>
<script>
    import { 
        contractList,
    } from "@/api/api.js";
    export default {
        name: "contractList",
        data(){
            return {
                page:1,
                count:0,
                list: [],
                load:true
            }
        },
        created(){
            // this.getList()
        },
        methods:{
        getList(){
            let data = {
                page:this.page
            }
            if (this.page > 1 && this.list.length >= this.count) {
                return false
            }
            if(!this.load){
                return false
            }
            this.load = false
            contractList(data).then(res=>{
                let n = []
                try {
                    let nn = res.data.list
                    if(this.page == 1){
                        n = nn
                    }else{
                        n = this.list
                        n = n.concat(nn)
                    }
                    this.list=n
                    this.count=res.data.count
                    this.page++
                } catch (error) {
                    console.log(error)
                    location.reload()
                }
                this.load = true
            })
        },
        info(id){
            this.$router.push({ name: 'contractInfo',query:{id:id} })
        }
    }
}
</script>    
<style lang="scss" scoped>
    .body{
        background-color: #f2f2f2;
        width: 100%;
        height: 100%;
    }
    .contractList{
        text-align: left;
        background-color: #fff;
        width: 800px;
        height: 100%;
        margin: 0 auto;
        .infinite-list{
            height: 100%;
        }
        .infinite-list-item{
            font-size: 18px;
            padding: 10px;
            border-bottom: 1px solid #f2f2f2;
            .listRight{
                line-height: 40px;
                text-align: right;
            }
            .listRight,.num{
                color: #b6b6b6;
            }
            .listLeft{
                
            }
            .num{
                font-size: 14px;
            }
        }
    }
</style>